<template>
  <div>
    <b-row>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>Birinchi o'quv yili (PhD):</strong>
          </p>
          <ol>
            <li>"Yakka tartibdagi reja  (5 MB gacha)" (pdf).</li>
            <li>"Nazariy-metodologik dastur (5 MB gacha)" (pdf).</li>
            <li>"Ilmiy maqola (5 MB gacha)" (pdf). (Kamida bitta)</li>
            <li>"Tezis (5 MB gacha)" (pdf). (Kamida bitta)</li>
            <li>"Dissertatsiya mavzusi bo'yicha tahliliy ma'lumot (5 MB gacha)" (pdf).</li>
            <li>"Seminar bayonnomasi (5 MB gacha)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>Ikkinchi o'quv yili (PhD):</strong>
          </p>
          <ol>
            <li>"Ilmiy maqola (5 MB gacha)" (pdf). (Kamida bitta)</li>
            <li>"Tezis (5 MB gacha)" (pdf). (Kamida bitta)</li>
            <li>"Xorijiy ilmiy maqola (5 MB gacha)" (pdf). (Kamida bitta)</li>
            <li>"Seminar bayonnomasi (5 MB gacha)" (pdf).</li>
            <li>"Hisobot (5 MB gacha)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>Uchinchi o'quv yili (PhD):</strong>
          </p>
          <ol>
            <li>"Ilmiy maqola (5 MB gacha)" (pdf). (Kamida bitta)</li>
            <li>"Tezis (5 MB gacha)" (pdf). (Kamida bitta)</li>
            <li>"Xorijiy ilmiy maqola (5 MB gacha)" (pdf). (Kamida bitta)</li>
            <li>"Dissertatsiya (15 MB gacha)" (pdf).</li>
            <li>"Dissertatsiya avtoreferati (7 MB gacha)" (pdf).</li>
            <li>"Seminar bayonnomasi (5 MB gacha)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>Birinchi o'quv yili (DSc):</strong>
          </p>
          <ol>
            <li>"Yakka tartibdagi reja (5 MB gacha)" (pdf).</li>
            <li>"Ilmiy maqola (5 MB gacha)" (pdf). (Kamida uchta)</li>
            <li>"Tezis (5 MB gacha)" (pdf). (Kamida bitta)</li>
            <li>"Seminar bayonnomasi (5 MB gacha)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>Ikkinchi o'quv yili (DSc):</strong>
          </p>
          <ol>
            <li>"Ilmiy maqola (5 MB gacha)" (pdf). (Kamida uchta)</li>
            <li>"Xorijiy ilmiy maqola (5 MB gacha)" (pdf). (Kamida bitta)</li>
            <li>"Tezis (5 MB gacha)" (pdf). (Kamida bitta)</li>
            <li>"Seminar bayonnomasi (5 MB gacha)" (pdf).</li>
            <li>"Hisobot (5 MB gacha)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>Uchinchi o'quv yili (DSc):</strong>
          </p>
          <ol>
            <li>"Ilmiy maqola (5 MB gacha)" (pdf). (Kamida uchta)</li>
            <li>"Monografiya (15 MB gacha)" (pdf). (Ijtimoiy-gumanitar fanlar uchun)</li>
            <li>"Dissertatsiya (15 MB gacha)" (pdf).</li>
            <li>"Dissertatsiya avtoreferati (7 MB gacha)" (pdf).</li>
            <li>"Seminar bayonnomasi  (5 MB gacha)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
    </b-row>
    <b-card
      id="guide"
      style="font-family: TimesNewRoman,serif; font-size: 18px"
    >
      <p style="font-size: 20px;">
        <strong>Birinchi o'quv yili (Stajor-tadqiqotchi):</strong>
      </p>
      <ol>
        <li>"Yakka tartibdagi reja (5 MB gacha)" (pdf).</li>
        <li>"Ilmiy maqola (5 MB gacha)" (pdf). (Kamida bitta)</li>
        <li>"Tezis (5 MB gacha)" (pdf). (Kamida bitta)</li>
      </ol>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCol, BRow } from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCard,
    BCol,
  },
}
</script>

<style scoped>
</style>
